import { render, staticRenderFns } from "./OfficeSignature.vue?vue&type=template&id=66d82abb&"
import script from "./OfficeSignature.vue?vue&type=script&lang=js&"
export * from "./OfficeSignature.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSignature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d82abb')) {
      api.createRecord('66d82abb', component.options)
    } else {
      api.reload('66d82abb', component.options)
    }
    module.hot.accept("./OfficeSignature.vue?vue&type=template&id=66d82abb&", function () {
      api.rerender('66d82abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/components/OfficeSignature.vue"
export default component.exports